import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// --- ACCREDITATION LOGO IMPORTS ---
import acclaimLogo from '../assets/accreditationlogos/Acclaim-accreditation-logo.png';
import acsLogo from '../assets/accreditationlogos/ACS-logo.png';
import armedForcesLogo from '../assets/accreditationlogos/Armed-Forces-Covenant-logo.png';
import bicscLogo from '../assets/accreditationlogos/BICSc-logo.png';
import constructionLineLogo from '../assets/accreditationlogos/Construction-line-gold-member-logo.png';
import disabilityConfidentLogo from '../assets/accreditationlogos/Disability-confident-logo.png';
import investorsInPeopleLogo from '../assets/accreditationlogos/Investors-in-people-logo.png';
import iso9001Logo from '../assets/accreditationlogos/ISO-9001-logo.png';
import iso14001Logo from '../assets/accreditationlogos/ISO-14001-logo.png';
import iso45001Logo from '../assets/accreditationlogos/ISO-45001-logo.png';
import nasduLogo from '../assets/accreditationlogos/NASDU-logo.png';
import risqsLogo from '../assets/accreditationlogos/RISQS-logo.png';
import safeContractorLogo from '../assets/accreditationlogos/Safe-contractor-logo.png';
// pacesetterLogo removed

const Contact = () => {
  // Pacesetter removed from array
  const accreditationLogos = [
    { src: acclaimLogo, alt: "Acclaim Accreditation" },
    { src: acsLogo, alt: "ACS" },
    { src: armedForcesLogo, alt: "Armed Forces Covenant" },
    { src: bicscLogo, alt: "BICSc" },
    { src: constructionLineLogo, alt: "Construction Line Gold" },
    { src: disabilityConfidentLogo, alt: "Disability Confident" },
    { src: investorsInPeopleLogo, alt: "Investors in People" },
    { src: iso9001Logo, alt: "ISO 9001" },
    { src: iso14001Logo, alt: "ISO 14001" },
    { src: iso45001Logo, alt: "ISO 45001" },
    { src: nasduLogo, alt: "NASDU" },
    { src: risqsLogo, alt: "RISQS" },
    { src: safeContractorLogo, alt: "Safe Contractor" }
  ];

  // Logic for the interactive logo slider
  const [startIndex, setStartIndex] = useState(0);
  const logosToShow = 5; 

  const handleNextLogos = () => {
    setStartIndex((prevIndex) => 
      (prevIndex + logosToShow) >= accreditationLogos.length ? 0 : prevIndex + logosToShow
    );
  };

  const handlePrevLogos = () => {
    setStartIndex((prevIndex) => 
      (prevIndex - logosToShow) < 0 ? Math.max(0, accreditationLogos.length - logosToShow) : prevIndex - logosToShow
    );
  };

  const visibleLogos = accreditationLogos.slice(startIndex, startIndex + logosToShow);

  return (
    <div className="contact-page">
      
      {/* INJECTED STYLES FOR PAGE OVERRIDES & MOBILE FIXES */}
      <style>
        {`
          /* --- REMOVE GLOBAL HERO ARROW JUST FOR THIS PAGE --- */
          .contact-hero::after {
            display: none !important;
          }

          /* Default desktop nowrap */
          .hero-nowrap { white-space: nowrap; }

          /* --- PREMIUM MOBILE RESPONSIVE FIXES --- */
          @media (max-width: 992px) {
            .contact-grid { grid-template-columns: 1fr; gap: 3rem; }
            .form-row { display: flex !important; flex-direction: column !important; gap: 0 !important; }
          }

          @media (max-width: 768px) {
            /* Hero adjustments to prevent overlap with header */
            .hero-nowrap { white-space: normal; } 
            .contact-hero { padding: 13rem 1.5rem 5rem 1.5rem !important; }
            .contact-hero h1 { font-size: 2.5rem !important; line-height: 1.2 !important; }
            .contact-hero p.subtitle { font-size: 1.1rem !important; }

            /* Enforce global container boundaries */
            .container { padding-left: 1.5rem !important; padding-right: 1.5rem !important; }

            /* Contact specifics */
            .contact-main-section { padding-top: 4rem !important; padding-bottom: 4rem !important; }
            .contact-details { padding: 2.5rem 1.5rem !important; }
            .contact-form-container { padding: 1rem 0 !important; }

            .accreditation-carousel-section { padding: 2rem 0 !important; }
          }
        `}
      </style>

      {/* 1. UNIFIED HERO SECTION */}
      <section className="contact-hero">
        <div className="container text-center">
          <h1><span className="hero-nowrap">Contact Us</span></h1>
          <p className="subtitle" style={{ fontSize: 'var(--fs-h3)' }}>
            Our National Operations Centre is available 24/7 to assist with your security requirements.
          </p>
        </div>
      </section>

      {/* 2. MAIN CONTACT SECTION (Mature & Confident Typography-led Layout) */}
      <section className="contact-main-section container" style={{ paddingTop: '8rem', paddingBottom: '8rem' }}>
        <div className="contact-grid">
          
          {/* Left Side: Contact Information Card (Upgraded to Premium Navy) */}
          <div className="contact-details" style={{ backgroundColor: 'var(--color-primary-navy)', color: 'var(--color-white)', padding: '4rem 3rem', borderRadius: '12px', boxShadow: '0 20px 40px rgba(0,0,0,0.15)' }}>
            <h2 style={{ color: 'var(--color-white)', marginBottom: '1rem', fontSize: 'var(--fs-h2)' }}>Direct Access</h2>
            <p style={{ color: 'var(--color-secondary-light)', marginBottom: '3rem', fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)' }}>
              Reach out to our executive team for a confidential discussion regarding your specific security, asset protection or consultancy needs.
            </p>
            
            <div className="contact-info-list" style={{ display: 'flex', flexDirection: 'column', gap: '2.5rem' }}>
              <div className="info-item" style={{ borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '2.5rem' }}>
                <span style={{ fontSize: 'var(--fs-small)', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--color-secondary-light)', display: 'block', marginBottom: '0.75rem' }}>
                  Headquarters
                </span>
                <p style={{ margin: 0, color: 'var(--color-white)', fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)' }}>
                  81 Crewe Road, Alsager<br />
                  Stoke On Trent, ST7 2EZ<br />
                  United Kingdom
                </p>
              </div>

              <div className="info-item" style={{ borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '2.5rem' }}>
                <span style={{ fontSize: 'var(--fs-small)', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--color-secondary-light)', display: 'block', marginBottom: '0.75rem' }}>
                  Executive Enquiries
                </span>
                <a href="mailto:info@nightmarkprotectiveservices.com" style={{ color: 'var(--color-white)', fontWeight: '500', fontSize: 'var(--fs-body)', textDecoration: 'none' }}>
                  info@nightmarkprotectiveservices.com
                </a>
              </div>

              <div className="info-item">
                <span style={{ fontSize: 'var(--fs-small)', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--color-secondary-light)', display: 'block', marginBottom: '0.75rem' }}>
                  24/7 Operations Centre
                </span>
                <a href="tel:08001234567" style={{ fontFamily: 'var(--font-heading)', fontSize: '2rem', fontWeight: '800', color: 'var(--color-white)', textDecoration: 'none', letterSpacing: '-0.5px' }}>
                  01270 446302
                </a>
              </div>
            </div>
          </div>

          {/* Right Side: Contact Form */}
          <div className="contact-form-container" style={{ padding: '2rem 1rem' }}>
            <h2 style={{ marginBottom: '1rem', color: 'var(--color-primary-dark)', fontSize: 'var(--fs-h2)' }}>Submit an Enquiry</h2>
            <p style={{ marginBottom: '2.5rem', color: 'var(--color-secondary-grey)', fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)' }}>
              Please complete the form below. A member of our specialist team will review your requirements and respond within 24 hours. All communications are bound by strict non-disclosure protocols.
            </p>
            
            <form className="page-contact-form">
              <div className="form-group">
                <label htmlFor="name" style={{ fontWeight: '600', color: 'var(--color-primary-dark)', fontSize: 'var(--fs-small)' }}>Full Name *</label>
                <input type="text" id="name" placeholder="John Doe" required style={{ padding: '1.25rem', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '8px', width: '100%', outline: 'none', fontSize: 'var(--fs-body)' }} />
              </div>
              
              <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
                <div className="form-group">
                  <label htmlFor="email" style={{ fontWeight: '600', color: 'var(--color-primary-dark)', fontSize: 'var(--fs-small)' }}>Email Address *</label>
                  <input type="email" id="email" placeholder="john@company.com" required style={{ padding: '1.25rem', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '8px', width: '100%', outline: 'none', fontSize: 'var(--fs-body)' }} />
                </div>
                <div className="form-group">
                  <label htmlFor="phone" style={{ fontWeight: '600', color: 'var(--color-primary-dark)', fontSize: 'var(--fs-small)' }}>Contact Number *</label>
                  <input type="tel" id="phone" placeholder="07000 000 000" required style={{ padding: '1.25rem', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '8px', width: '100%', outline: 'none', fontSize: 'var(--fs-body)' }} />
                </div>
              </div>

              {/* UPDATED SERVICES DROPDOWN */}
              <div className="form-group">
                <label htmlFor="service" style={{ fontWeight: '600', color: 'var(--color-primary-dark)', fontSize: 'var(--fs-small)' }}>Subject</label>
                <select id="service" style={{ padding: '1.25rem', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '8px', width: '100%', outline: 'none', backgroundColor: 'var(--color-white)', fontSize: 'var(--fs-body)' }}>
                  <option value="">Please select a division...</option>
                  <option value="corporate-security">Corporate Security</option>
                  <option value="concierge">Concierge Services</option>
                  <option value="key-holding">Key Holding & Alarm Response</option>
                  <option value="mobile-patrols">Mobile Patrols</option>
                  <option value="martyns-law">Martyn's Law</option>
                  <option value="media ">Media Relations</option>
                  <option value="careers">Careers</option>
                  <option value="general">General Operations Enquiry</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message" style={{ fontWeight: '600', color: 'var(--color-primary-dark)', fontSize: 'var(--fs-small)' }}>Operational Details *</label>
                <textarea id="message" rows="6" placeholder="Please provide brief details of your security requirements..." required style={{ padding: '1.25rem', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '8px', width: '100%', outline: 'none', resize: 'vertical', fontSize: 'var(--fs-body)' }}></textarea>
              </div>

              <button type="submit" className="btn btn-primary btn-pill submit-btn" style={{ padding: '1.25rem 3rem', fontSize: 'var(--fs-body)', fontWeight: '700', marginTop: '1rem' }}>
                Send
              </button>
            </form>
          </div>
          
        </div>
      </section>

      {/* 3. ACCREDITATION CAROUSEL STRIP (Navy Block Removed) */}
      <section className="accreditation-carousel-section" style={{ backgroundColor: 'var(--color-white)', padding: '4rem 0', borderTop: '1px solid rgba(0,0,0,0.05)' }}>
        <div className="container">
          
          <div className="accreditation-interactive-wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '2rem' }}>
            
            {/* Left Control Button */}
            <button 
              className="control-btn prev-btn" 
              onClick={handlePrevLogos} 
              aria-label="Previous Logos"
              style={{ backgroundColor: 'var(--color-light)', border: 'none', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--color-primary-navy)', fontSize: '1.5rem', fontWeight: 'bold' }}
            >
              ‹
            </button>

            {/* Logo Display Grid (Shows 5 max) */}
            <div className="accreditation-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '2rem', width: '100%', alignItems: 'center', justifyItems: 'center' }}>
              {visibleLogos.map((logo, index) => (
                <div className="accreditation-slide-static" key={index}>
                  <img 
                    src={logo.src} 
                    alt={logo.alt} 
                    style={{ maxHeight: '70px', objectFit: 'contain' }}
                  />
                </div>
              ))}
            </div>

            {/* Right Control Button */}
            <button 
              className="control-btn next-btn" 
              onClick={handleNextLogos} 
              aria-label="Next Logos"
              style={{ backgroundColor: 'var(--color-light)', border: 'none', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--color-primary-navy)', fontSize: '1.5rem', fontWeight: 'bold' }}
            >
              ›
            </button>

          </div>

        </div>
      </section>

    </div>
  );
};

export default Contact;